<template>
    <b-modal ref="modal" centered no-close-on-backdrop no-close-on-esc no-enforce-focus
        class="modal-dialog modal-dialog-centered">
        <template #modal-title>
            {{ $tc("Global.New", 2) }} {{ $t("Management.Areas.Area") }}
        </template>
        <validation-observer ref="rules" tag="form" class="p-2" @submit.prevent="submit">
            <section v-if="area">
                <b-form-group :label="$t('Management.Areas.Area')" label-for="area">
                    <validation-provider #default="{ errors }" :name="$t('Management.Areas.Area')" rules="required">
                        <b-form-input id="area" v-model="area.name" :placeholder="
                            $t('Global.Write', {
                                subject: $t('Management.Areas.Area'),
                            })
                        " :state="errors.length > 0 ? false : null" :disabled="!can" autocomplete="off" />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>

                <b-form-group :label="$t('Management.Areas.Short')" label-for="short">
                    <validation-provider #default="{ errors }" :name="$t('Management.Areas.Short')" rules="required">
                        <b-form-input id="short" v-model="area.short" :placeholder="
                            $t('Global.Write', {
                                subject: $t('Management.Areas.Short'),
                            })
                        " :state="errors.length > 0 ? false : null" :disabled="!can" autocomplete="off" />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>

                <b-form-group :label="$t('Management.Countries.Country')" label-for="country">
                    <div class="select-container">
                        <div class="country-select">
                            <v-select id="country" v-model="area.country" :placeholder="
                                $t('Global.Select', {
                                    subject: $t('Management.Countries.Country'),
                                })
                            " :options="countries" :disabled="!can" :label="'name'">
                            <div slot="no-options">{{ $t("Global.NothingFound") }}</div>
                                <template #option="{ name }">
                                    <div class="d-flex">
                                        {{ name }}
                                    </div>
                                </template>
                                <template #selected-option="{ name }">
                                    <div>{{ name }}</div>
                                </template>

                            </v-select>
                        </div>
                    </div>
                </b-form-group>


            </section>
        </validation-observer>
        <template #modal-footer>
            <div class="buttons-container d-flex">
                <b-button v-if="can" v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" @click="submit">
                    {{ $t("Global.Save") }}
                </b-button>

                <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="outline-secondary"
                    @click="modalVisible = false">
                    {{ $t("Global.Retreat") }}
                </b-button>
            </div>
        </template>
    </b-modal>
</template>
  
<script>
import { BButton, BFormInput, BFormGroup } from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { preventUnsavedChangesPopupLevel } from "@/utility/mixins/preventUnsavedChanges";
import { required } from "@validations";
import vSelect from "vue-select";
export default {
    components: {
        vSelect,
        ValidationProvider,
        ValidationObserver,
        BButton,
        BFormInput,
        BFormGroup,
    },

    mixins: [preventUnsavedChangesPopupLevel],

    props: {
        can: {
            type: Boolean,
            required: true,
        },
        countries: {
            type: Array,
            default: () => [],
        },
    },

    data: () => ({
        required,
        area: {
            name: null,
            short: null,
        },
    }),

    methods: {
        async reset() {
            this.area = {
                name: null,
                short: null,
            }
            this.$refs.rules.reset();
            this.$emit("resetArea");
        },
        async submit() {
            const valid = await this.$refs.rules.validate();
            this.area.country = this.area.country.id;
            if (valid) {
                const { data } = await this.$axios.post('areas', this.area);
                this.area = data;
                this.$alert.create(`${data.name}`);

                this.$emit("submitArea", data);
                return;
            }
            this.$alert.invalid();
        },
    },
};
</script>
<style lang="scss">
.buttons-container {
    gap: 1rem;
}
</style>
  